// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox__3K1BN","radio_btn":"radio_btn__1znyb"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/style.scss
// module id = 04o6
// module chunks = 13